<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-navigation-drawer
    :model-value="isOpen"
    location="left"
    @update:model-value="$emit('update:toggleVisible')"
  >
    <template #prepend>
      <slot name="prepend" />
    </template>
    <slot />
    <template #append>
      <slot name="append" />
    </template>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
  defineProps({
    isOpen: {
      type: Boolean,
      default: false,
    },
  });

  defineEmits(['update:toggleVisible']);
</script>

<style scoped>
  /** All scoped css here */
</style>
